import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap";
var ViewDefectsComponent = /** @class */ (function () {
    function ViewDefectsComponent(bsModalRef) {
        this.bsModalRef = bsModalRef;
        this.currentIndex = 0;
        this.keyListener = function (event) { };
    }
    ViewDefectsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.onClose = new Subject();
        if (this.defectStages && this.defectStages.length) {
            this.selectedStage = this.defectStages.find(function (stage) { return stage.id == _this.defect.currentStage; });
        }
        else {
            this.selectedStage = {
                id: this.defect.currentStageId,
                name: this.defect.currentStage,
                color: this.defect.stagecolor
            };
        }
        this.title = this.defect.issueType == 'defects' ? 'Defect details' : 'Recommendation details';
        this.imageUrl = this.defect && this.defect.defectImages && this.defect.defectImages[0] || null;
        if (this.defect.defectImages && this.defect.defectImages.length) {
            this.currentIndex = 0;
            document.body.classList.add('defect-media-mode');
        }
        this.keyListener = function (event) {
            if (_this.defect && _this.defect.defectImages && !_this.defect.defectImages.length)
                return;
            if (event.key === 'ArrowRight') {
                _this.showNextImage();
            }
            if (event.key === 'ArrowLeft') {
                _this.showPreviousImage();
            }
        };
        window.addEventListener('keydown', this.keyListener);
    };
    ViewDefectsComponent.prototype.close = function () {
        this.bsModalRef.hide();
        this.onClose.next();
        setTimeout(function () {
            document.body.classList.remove('defect-media-mode');
        }, 250);
    };
    ViewDefectsComponent.prototype.downloadImg = function (imageSrc) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var image, imageBlog, imageURL, link;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(imageSrc)];
                    case 1:
                        image = _a.sent();
                        return [4 /*yield*/, image.blob()];
                    case 2:
                        imageBlog = _a.sent();
                        imageURL = URL.createObjectURL(imageBlog);
                        link = document.createElement('a');
                        link.href = imageURL;
                        link.download = imageSrc.split('/').pop();
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewDefectsComponent.prototype.changeDefaultImage = function (url) {
        this.imageUrl = url;
        this.currentIndex = this.defect.defectImages.indexOf(url);
    };
    ViewDefectsComponent.prototype.ngOnDestroy = function () {
        window.removeEventListener('keydown', this.keyListener);
        setTimeout(function () {
            document.body.classList.remove('defect-media-mode');
        }, 250);
    };
    ViewDefectsComponent.prototype.showNextImage = function () {
        if (!this.defect.defectImages.length)
            return;
        this.currentIndex =
            (this.currentIndex + 1) % this.defect.defectImages.length;
        this.imageUrl = this.defect.defectImages[this.currentIndex];
    };
    ViewDefectsComponent.prototype.showPreviousImage = function () {
        if (!this.defect.defectImages.length)
            return;
        this.currentIndex =
            (this.currentIndex - 1 + this.defect.defectImages.length) %
                this.defect.defectImages.length;
        this.imageUrl = this.defect.defectImages[this.currentIndex];
    };
    return ViewDefectsComponent;
}());
export { ViewDefectsComponent };
